import { Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OtherTemplatesService } from '../../home/services/other-templates.service';
import { DocsNames } from '../../dto/docs-names';
import { DomSanitizer } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {InvoiceInfoService} from '../services/invoice-info.service';

@Component({
  selector: 'app-view-docs',
  templateUrl: './payment-upload-success.component.html',
  styleUrls: ['./payment-upload-success.component.css'],

})
export class PaymentUploadSuccessComponent implements OnInit {


  constructor(

    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private invoiceInfoService: InvoiceInfoService,

  ) { }


  protectedInvoiceCode: string = null;
  intervalId: ReturnType<typeof setTimeout>;
  loading = false;

  ngOnInit() {

    this.route.queryParams.subscribe((params: Params) => {

      const code = params['i'];
      this.protectedInvoiceCode = code;

      if( code ){
        this.loading = true;
        this.intervalId = setInterval(() => this.pollInvoice(code), 5000);
      }

    });

  }

  pollInvoice(code: string){
    this.invoiceInfoService.getLinkTokengByProtectedCodeIfPaid(this.protectedInvoiceCode).subscribe(
      (token: string) => {
        window.location.href = '/upload-docs/'+token;
        this.loading = false;
      });
    error => {
      this.loading = true;
    };
  }

}
